import FormatQuoteIcon from '@mui/icons-material/FormatQuote';
import StarIcon from '@mui/icons-material/Star';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Rating from '@mui/material/Rating';
import Typography from '@mui/material/Typography';
import { storyblokEditable } from '@storyblok/react';
import { memo } from 'react';

import { petrol, yellow } from '../../../styles/mui/colors';
import useStoryblokImage from '../../../util/hooks/useStoryblokImage';
import ProgressiveImage from '../../Image/ProgressiveImage';
import { withBaseComponent } from '../hoc/withBaseComponent';

/**
 * @param {object} props
 * @param {object} props.blok
 */
const StoryblokReviewCardComponent = ({ blok }) => {
  const { general } = blok;
  const { name, subTitle, content, rating, image } = general;
  const { src, blurSrc, blurSources, sources } = useStoryblokImage(image.filename, {
    size: 320,
    blurSize: 160,
  });

  return (
    <Box
      sx={{
        position: 'relative',
        ...(image && image.filename ? { paddingTop: '85px' } : {}),
      }}
      {...storyblokEditable(blok)}
    >
      {image && image.filename ? (
        <Box
          sx={{
            position: 'absolute',
            borderRadius: '50%',
            overflow: 'hidden',
            width: '150px',
            height: '150px',
            left: 'calc(50% - 75px)',
            top: '0',
            border: '10px solid white',
          }}
        >
          <ProgressiveImage
            alt={image.alt}
            blurSources={blurSources}
            height="130px"
            imageStyle={{
              objectFit: 'contain',
            }}
            placeholder={blurSrc}
            sources={sources}
            src={src}
          />
        </Box>
      ) : null}
      <Paper
        sx={{
          backgroundColor: petrol.main,
          padding: 2,
          ...(image && image.filename ? { pt: 8 } : {}),
        }}
      >
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Typography color="white" component="p" textAlign="center" variant="body1">
            <FormatQuoteIcon sx={{ color: yellow.main }} />
            {content}
            <FormatQuoteIcon sx={{ color: yellow.main }} />
          </Typography>
        </Box>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Rating
            emptyIcon={<StarIcon fontSize="inherit" style={{ color: '#fff' }} />}
            readOnly
            sx={{
              marginRight: 2,
            }}
            value={parseInt(rating)}
          />
          <Typography color={yellow.main} component="p" variant="body1">
            {`${name} `}
          </Typography>
          <Typography color="white" component="p" variant="body1">
            &mdash; {subTitle}
          </Typography>
        </Box>
      </Paper>
    </Box>
  );
};

StoryblokReviewCardComponent.displayName = 'StoryblokReviewCard';
const StoryblokReviewCard = withBaseComponent(StoryblokReviewCardComponent);
export default memo(StoryblokReviewCard);
